import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from "./components/AdminLayout";
import AdminRoute from "./components/AdminRoute";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import Users from "./pages/Users";
import Finance from "./pages/Finance";
import Bonuses from "./pages/Bonuses";
import AuditLogs from "./pages/AuditLogs";
import Operations from "./pages/Operations";
import TradeManagement from "./pages/TradeManagement";
import StakeManagement from "./pages/StakeManagement";
import TeamManagement from "./pages/TeamManagement";
import WithdrawalManagement from "./pages/WithdrawalManagement";
import DepositManagement from "./pages/DepositManagement";
import LicenseManagement from "./pages/LicenseManagement";
import UserDetails from "./pages/UserDetails";

function ProtectedPage({ children }) {
  return (
    <AdminRoute>
      <AdminLayout>{children}</AdminLayout>
    </AdminRoute>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/overview" replace />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/trades"
        element={
          <ProtectedPage>
            <TradeManagement />
          </ProtectedPage>
        }
      />
      <Route
        path="/stakes"
        element={
          <ProtectedPage>
            <StakeManagement />
          </ProtectedPage>
        }
      />
      <Route
        path="/team"
        element={
          <ProtectedPage>
            <TeamManagement />
          </ProtectedPage>
        }
      />
      <Route
        path="/withdrawals"
        element={
          <ProtectedPage>
            <WithdrawalManagement />
          </ProtectedPage>
        }
      />
      <Route
        path="/deposits"
        element={
          <ProtectedPage>
            <DepositManagement />
          </ProtectedPage>
        }
      />
      <Route
        path="/licenses"
        element={
          <ProtectedPage>
            <LicenseManagement />
          </ProtectedPage>
        }
      />
      <Route
        path="/overview"
        element={
          <ProtectedPage>
            <Overview />
          </ProtectedPage>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedPage>
            <Users />
          </ProtectedPage>
        }
      />
      <Route
        path="/users/:userId"
        element={
          <ProtectedPage>
            <UserDetails />
          </ProtectedPage>
        }
      />
      <Route
        path="/finance"
        element={
          <ProtectedPage>
            <Finance />
          </ProtectedPage>
        }
      />
      <Route
        path="/bonuses"
        element={
          <ProtectedPage>
            <Bonuses />
          </ProtectedPage>
        }
      />
      <Route
        path="/logs"
        element={
          <ProtectedPage>
            <AuditLogs />
          </ProtectedPage>
        }
      />
      <Route
        path="/operations"
        element={
          <ProtectedPage>
            <Operations />
          </ProtectedPage>
        }
      />
    </Routes>
  );
}
